import { render, staticRenderFns } from "./DrawerAssignerUserRole.vue?vue&type=template&id=73c616c0&"
import script from "./DrawerAssignerUserRole.vue?vue&type=script&lang=js&"
export * from "./DrawerAssignerUserRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports